import "swiper/css";
import "swiper/css/pagination";
import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

class SliderTestimonials {
  constructor() {
    this.init();
  }

  init() {
    const sliders = document.querySelectorAll(".swiper-testimonials");

    sliders.forEach((slider, index) => {
      slider.classList.add(`swiper-testimonials-${index}`);

      const pagination = slider.parentElement.querySelector(".swiper-pagination");
      pagination.classList.add(`swiper-pagination-${index}`);

      new Swiper(`.swiper-testimonials-${index}`, {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        autoHeight: true,

        pagination: {
          el: `.swiper-pagination-${index}`,
          clickable: true,
        },

        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });
    });
  }
}

export default SliderTestimonials;
